import { launchWebView, closeWebViewAndRedirectUrl } from "bridge/common/CommonBridge";
import _ from "lodash";

export const gotoDictWithWrappedLink = (link, type, obj) => {
    Object.keys(obj).forEach((key) => (link = link.replace(`{${key}}`, obj[key])));

    const param = {
        PGM_URL: link,
        PGM_SCRN_TY: "POP_F",
        PGM_NAME: "외부링크",
    };

    if (type === "REDIRECT") {
        closeWebViewAndRedirectUrl(param);
    } else if (type === "NEW_VIEW") {
        launchWebView(param);
    }
};

/**
 * @param  {...any} args
 * title : 출력할 제목
 * message : 출력할 데이터
 * color : 색상 (default : "dodgerblue")
 */
export const consoleLog = (...args) => {
    // if (String(process.env.REACT_APP_ENV).trim() === "real") return; // 운영 return

    const isNotEmpty = () => _.negate(_.isEmpty); // !isEmpty
    const isUndefined = _.isUndefined;

    const [title, message, color = "dodgerblue"] = args;

    if (isNotEmpty(title) && isUndefined(message)) {
        // title이 없고 message만 입력된 경우
        console.log(`%c [ ${typeof title} ] :: `, `color: ${color}; font-weight: bold`, title);
        return;
    }

    const convertTitle = title.charAt(0).toUpperCase() + title.slice(1); // 앞 글자만 대문자로
    const titleT = title ? "[ " + convertTitle + " ] :: " : "[ #none ] :: "; // 정돈

    console.log(`%c ${titleT}`, `color: ${color}; font-weight: bold`, message);
};

export const formatPhoneNumber = (input) => {
    const cleanInput = input.replaceAll(/[^0-9]/g, "");
    let result = "";
    const length = cleanInput.length;
    if (length === 8) {
        result = cleanInput.replace(/(\d{4})(\d{4})/, "$1-$2");
    } else if (cleanInput.startsWith("02") && (length === 9 || length === 10)) {
        result = cleanInput.replace(/(\d{2})(\d{3,4})(\d{4})/, "$1-$2-$3");
    } else if (!cleanInput.startsWith("02") && (length === 10 || length === 11)) {
        result = cleanInput.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
    } else {
        result = undefined;
    }
    return result;
};
